<template>
  <div>
    <dr-row class="tab_box" style="height: 50px;" justifyContent="flex-row" alignItems="center" flexFlow="nowrap">
      <dr-column class="tab_item" :style="{'width': 100/tabsArr.length + '%'}" alignItems="center" v-for="(item,index) in tabsArr" :key="index"
        @click="onTabChanged(index, item)">
        <div :class="tabActive == index ? 'tab_name_active' : 'tab_name'">{{item.text}}</div>
        <div v-if="tabActive == index" class="tab_line"></div>
        <div v-else class="tab_line_empty"></div>
      </dr-column>
    </dr-row>
  </div>
</template>

<script>
export default {
  props: {
    tabsArr: {
      type: Array,
      default: [],
    },
    defaultActive: {
      type: Number,
      default: 0,
    },
    hasDivider: {
      type: Boolean,
      default: true,
    },
    hasArrow: {
      type: Boolean,
      default: true,
    },
    iconName: {
      type: String,
      default: '',
    },
    rightContent: {
      type: String,
      default: '',
    },
    rightContentTextColor: {
      type: String,
      default: '#666666',
    },

  },
  watch: {
    defaultActive: {
      handler (val) {
        this.tabActive = val
      },
      immediate: true
    },
  },
  data () {
    return {
      tabActive: 0,
    }
  },
  mounted () {
    // this.tabActive = this.defaultActive
  },
  methods: {
    onTabChanged (index, item) {
      this.tabActive = index
      this.$emit('onTabChanged', index, item)
    },
  }
}
</script>

<style scoped>
.tab_box {
  /* height: 50px; */
  box-sizing: border-box;
  background-color: #ffffff;
  overflow-x: auto;
  overflow-y: hidden;
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 100;
}
.tab_item {
  width: 25%;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  flex: none;
  background: transparent;
  overflow: hidden;
}
.tab_name {
  font-size: 15px;
  color: #444444;
}
.tab_name_active {
  font-size: 15px;
  color: #0071ee;
}
.tab_line {
  width: 17px;
  height: 3px;
  background-color: #0071ee;
  margin-top: 5px;
  border-radius: 2px;
}
.tab_line_empty {
  width: 17px;
  height: 3px;
  background-color: #ffffff;
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/drTabs/index.vue